var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper hideSidebar"},[_c('div',{staticClass:"content-container"},[_c('screen-main')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }